import React from 'react'

export const Card = () => {
  return <div>CARD PAGE</div>
}
